import { PARTTIME_ROOT_PATH, FULLTIME_ROOT_PATH } from 'Configs/config';
export const FULLTIME_RESUME_TYPE = 'fulltime-resume';
export const FULLTIME_RESUME_ONLY_TYPE = 'fulltime-resume-only';
export const PARTTIME_RESUME_TYPE = 'parttime-resume';
export const SHOKUMU_RESUME_TYPE = 'shokumu';
export const SHOKUMU_RESUME_ONLY_TYPE = 'shokumu-only';
export const PARTTIME_RESUME_DEFAULT_ID = '0';
export const FULLTIME_RESUME_DEFAULT_ID = '1';
export const FULLTIME_RESUME_ONLY_DEFAULT_ID = '2';
export const SHOKUMU_RESUME_ONLY_DEFAULT_ID = '3';
const PARTTIME_REFERENCE_STRINGS = {
    downloadButtonElement: 'pt_download_button',
    backEndResumeType: 'part_time',
    rootPath: PARTTIME_ROOT_PATH,
    title: '履歴書',
    previewCssClass: 'Final-preview-resume Final-preview',
    previewPathPostFix: 'preview',
    printUrlPostFix: 'parttime'
};
const FULLTIME_REFERENCE_STRINGS = {
    downloadButtonElement: 'ft_download_button',
    backEndResumeType: 'full_time',
    rootPath: FULLTIME_ROOT_PATH,
    title: '履歴書',
    previewCssClass: 'Final-preview-resume Final-preview',
    previewPathPostFix: `${FULLTIME_RESUME_TYPE}/preview`,
    printUrlPostFix: FULLTIME_RESUME_TYPE
};
const SHOKUMU_REFERENCE_STRINGS = {
    downloadButtonElement: 'ft_download_button',
    backEndResumeType: 'full_time',
    rootPath: FULLTIME_ROOT_PATH,
    title: '職務経歴書',
    previewCssClass: 'Final-preview-shokumu Final-preview',
    previewPathPostFix: `${SHOKUMU_RESUME_TYPE}/preview`,
    printUrlPostFix: SHOKUMU_RESUME_TYPE
};
export const ReferenceStringsMapper = {
    [PARTTIME_RESUME_TYPE]: PARTTIME_REFERENCE_STRINGS,
    [FULLTIME_RESUME_TYPE]: FULLTIME_REFERENCE_STRINGS,
    [FULLTIME_RESUME_ONLY_TYPE]: FULLTIME_REFERENCE_STRINGS,
    [SHOKUMU_RESUME_TYPE]: SHOKUMU_REFERENCE_STRINGS,
    [SHOKUMU_RESUME_ONLY_TYPE]: SHOKUMU_REFERENCE_STRINGS
};
